import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password, remember = false) => {
    const { data } = await api.post("/auth/login", { email, password, remember });
    setUser(data);
    return data;
  }, []);

  const register = useCallback(async (name, email, password, remember = false) => {
    const { data } = await api.post("/auth/register", { name, email, password, remember });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, login, register, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
